import { n as o } from "./property-9daa16cd.mjs";
import { r as g } from "./state-7560d4dc.mjs";
import { e as h } from "./query-d94c86d2.mjs";
import { i as x, E as m, x as c, a as p, r as v } from "./createReactComponent-58f9bea8.mjs";
import { e as b } from "./class-map-2994e95e.mjs";
import { r as f } from "./icon-c572aa57.mjs";
const k = x`
  :host .link {
    position: relative;
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-none);
    border: var(--exo-spacing-3x-small) solid transparent;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font: var(--exo-text-body-large);
    color: var(--exo-text-link-standard-color);
    text-decoration: none;
  }

  :host .link--size-small {
    font: var(--exo-text-label-standard);
  }

  :host .link--size-x-small {
    font: var(--exo-text-label-micro);
  }

  :host [disabled].link,
  :host [disabled].link:focus {
    pointer-events: none;
    cursor: not-allowed;
    color: var(--exo-color-background-disabled);
    border: none;
    text-decoration: none;
  }
  :host .link:hover,
  :host .link:active {
    text-decoration: underline;
    color: var(--exo-color-font-link-hover);
  }

  :host .link:focus {
    color: var(--exo-color-font-link-hover);
    border: var(--exo-spacing-3x-small) solid
      var(--exo-text-link-standard-color);
    border-radius: var(--exo-spacing-2x-small);
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-none);
    box-shadow: none;
    outline: none;
    text-decoration: underline;
  }

  :host .leading-icon {
    margin-right: var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-3x-large);
    padding: var(--exo-spacing-none);
  }

  :host .trailing-icon {
    margin-left: var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-3x-large);
    padding: var(--exo-spacing-none);
  }

  :host .link--size-x-small .leading-icon,
  :host .link--size-x-small .trailing-icon,
  :host .link--size-small .leading-icon,
  :host .link--size-small .trailing-icon {
    font: var(--exo-text-label-medium);
  }
`;
var u = Object.defineProperty, y = Object.getOwnPropertyDescriptor, i = (t, e, s, l) => {
  for (var r, a = l > 1 ? void 0 : l ? y(e, s) : e, d = t.length - 1; d >= 0; d--)
    (r = t[d]) && (a = (l ? r(e, s, a) : r(a)) || a);
  return l && a && u(e, s, a), a;
}, z = ((t) => (t.BLANK = "_blank", t.SELF = "_self", t.PARENT = "_parent", t.TOP = "_top", t))(z || {}), I = ((t) => (t.SMALL = "small", t.DEFAULT = "default", t.XSMALL = "x-small", t))(I || {});
class n extends m {
  constructor() {
    super(...arguments), this.deactivated = !1, this.size = "default", this.href = "#", this.target = "_self", this.disabled = !1, this.leadingIcon = "", this.trailingIcon = "", this.leadingIconLabel = "", this.trailingIconLabel = "";
  }
  firstUpdated() {
    this.disabled && (this.deactivated = this.disabled, this.href = "#");
  }
  getAriaLabel() {
    var s;
    const e = (s = this.defaultSlot) == null ? void 0 : s.assignedNodes()[0];
    return (e == null ? void 0 : e.textContent) || "";
  }
  renderLeadingIcon() {
    return this.leadingIcon !== "" ? c`<span class="leading-icon"
        ><ex-icon
          icon=${this.leadingIcon}
          label=${this.leadingIconLabel}
        ></ex-icon
      ></span>` : p;
  }
  renderTrailingIcon() {
    return this.trailingIcon !== "" ? c`<span class="trailing-icon"
        ><ex-icon
          icon=${this.trailingIcon}
          label=${this.trailingIconLabel}
        ></ex-icon
      ></span>` : p;
  }
  onClickEvent(e) {
    this.href === "#" && e.preventDefault(), this.deactivated || this.dispatchCustomEvent("onClick", {});
  }
  onKeyDownEvent(e) {
    !this.disabled || e.key !== "Enter" && e.key !== "Tab" || e.preventDefault();
  }
  render() {
    return c`
      <a
        slot="anchor"
        role="link"
        part="link"
        class=${b({ link: !0, "link--size-default": this.size === "default", "link--size-small": this.size === "small", "link--size-x-small": this.size === "x-small" })}
        href="${this.href}"
        target="${this.target}"
        aria-disabled=${this.disabled}
        ?disabled=${this.disabled}
        aria-label=${this.getAriaLabel()}
        @click=${(e) => this.onClickEvent(e)}
        @keydown="${(e) => this.onKeyDownEvent(e)}"
      >
        ${this.renderLeadingIcon()}
        <slot class="slot"></slot>
        ${this.renderTrailingIcon()}
      </a>
    `;
  }
}
n.styles = k, i([g()], n.prototype, "deactivated", 2), i([h("slot")], n.prototype, "defaultSlot", 2), i([o()], n.prototype, "size", 2), i([o({ type: String })], n.prototype, "href", 2), i([o()], n.prototype, "target", 2), i([o({ type: Boolean, reflect: !0 })], n.prototype, "disabled", 2), i([o({ type: String })], n.prototype, "leadingIcon", 2), i([o({ type: String })], n.prototype, "trailingIcon", 2), i([o({ type: String })], n.prototype, "leadingIconLabel", 2), i([o({ type: String })], n.prototype, "trailingIconLabel", 2);
const T = (t = "") => {
  v("ex-link", n, t), f(t);
};
export {
  I as L,
  z as T,
  n as a,
  T as r
};
